<template>
  <dynamic-object-form-structure
    :object-uuid="objectUUID"
    :object-layer="objectLayer"
    :loading-structure="loadingStructure"
    :loading-save="loadingSave"
    :permission-name="form.permission"
    :object-type-translation-key="form.name_translation"
    :tabs="visibleTabs"
    :saveIsDisabled="!required.filled"
    :active-tab="activeTab"
    :action-type="actionType"
    :map-element="$parent.$refs.formsContainer"
    :previous-pos-x="previousPosX"
    :previous-pos-y="previousPosY"
    :data-was-changed="dataWasChanged"
    :fields-still-need-filled="required.stillNeedFilled"
    @updateActiveTab="activeTab = $event"
    @changeViewMode="changeViewModeOfObject"
    @openDetails="openDetails"
    @refresh="refresh"
    @clearData="clearData"
    @save="saveObject"
    @close="closeForm"
    :object-data="objectData"
  >
    <template v-slot:formFields>
      <div
        v-show="visibleTabs[activeTab].type === 'form'"
        class="form tab-content"
      >
        <input-field
          v-for="field in visibleTabs[activeTab].fields"
          :key="visibleTabs[activeTab].code + field.label + field.order"
          ref="formInputField"
          :value="getValueInObject(field.var_name, field.input_type)"
          @input="setValueInObject(field.var_name, $event, field.input_type)"
          :label="field.label_client ? field.label_client : field.label"
          :variable-name="field.var_name"
          :inputType="field.input_type"
          :size="field.size"
          :required="field.required"
          :required-filled="required.filled"
          :selectOptions="field.select_list_name"
          :radioOptions="field.radio_options"
          :fieldDisabled="field.disable"
          :tabDisabled="!userCanEditTabContent(visibleTabs[activeTab])"
          :formDisabled="readOnly"
          :hide="field.hide"
          :automatic-label="field.has_automatic_label"
          @generateLabel="getAutomaticLabel(autoLabelRequestData)"
          :checkboxOptions="field.checkbox_options"
          :object-data="objectData"
          :labelIsLocked="objectData.st_label_locked"
          :user-can-unlock-label="!userHasFibercloudPermission(form.permission + '_manage_label')"
          @toggle-label-lock="changeLabelMode"
          @updateCheckboxValue="updateCheckboxValue($event)"
          @removePhoto="addToPhotosToRemove($event)"
        />
      </div>
      <custom-fields-tab
        v-if="visibleTabs[activeTab].code === 'custom_fields'"
        :customFields="customFields.custom_fields"
        :objectData="objectData.custom_fields"
        :actionType="actionType"
        :disabled="readOnly"
        @updateValue="setValueInObject"
        :requiredFilled="required.filled"
      />
    </template>

    <template v-slot:dialogBox>
      <app-dialog-box
        :open="dialog"
        :isPersistent="true"
        :title="$t('TechnicalSiteDialog.createTechnicalLocalTitle')"
        :content="$t('TechnicalSiteDialog.createTechnicalLocalText')"
        :main-action-label="$t('Yes')"
        @mainAction="createTechnicalLocal('Site')"
        :secondary-action-label="$t('No')"
        @secondaryAction="closeDialog"
      />
    </template>
  </dynamic-object-form-structure>
</template>

<script>
import { dynamicObjectFormsMixin } from "@/mixins/forms/dynamicObjectForms/dynamicObjectFormsMixin";
import DynamicObjectFormStructure from "@/components/Home/Forms/_Templates/DynamicObjectFormStructure";
import InputField from "@/components/Home/Forms/_Molecules/InputField";
import { bus } from "@/main";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";
import CustomFieldsTab from "@/components/Home/Forms/_SpecialTabs/CustomFields/CustomFieldsTab.vue";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "SiteForm",

  components: {
    AppDialogBox,
    InputField,
    DynamicObjectFormStructure,
    CustomFieldsTab
  },

  mixins: [dynamicObjectFormsMixin,checkPermissionsMixin],

  props: {
    linkObjectToPathway: {
      type: Object
    }
  },

  data() {
    return {
      technicalSiteData: {},

      dialog: false
    };
  },

  methods: {
    createObject() {
      this.createDataToSend();

      this.CREATE_OBJECTS({
        endpoint: this.form.endpoint,
        data: [this.dataToSend]
      })
        .then(resp => {
          if (this.linkObjectToPathway.split) {
            bus.$emit("reset-pathway-and-split-data");
          }

          this.technicalSiteData = resp.data.data[0];
          this.dialog = true;
          this.updateObjectLocalStorageData();
          this.$toasted.global.toast_success(this.$i18n.t("CreationSuccess"));
        })
        .catch(error => {
          this.$toasted.global.toast_error(error.response.data.data);
          this.loadingSave = false;
        });
    },

    createDataToSend() {
      this.dataToSend = {
        technical_site: {
          status: this.objectData.st_status,
          physical_type: "SIT",
          logical_type: "TWO",
          node: {
            projection: 3857,
            text_geom: this.wkt
          }
        }
      };
      if (this.linkObjectToPathway.split) {
        this.dataToSend.technical_site.node.delete_pathways_association =
          "false";
        this.dataToSend.technical_site.node.pathway = this.linkObjectToPathway.pathway;
      }
      this.placeObjectDataInDataToSend();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/ObjectForms/SiteForm.vue